// sbKeys where a smart baseline price has been applied, so the price cell can be marked.
export interface AppliedSmartBaselineMeta {
  confScore: number;
  flavorLabel: string;
  price: number;
}

export const appliedSmartBaselineKeys = new Map<string, AppliedSmartBaselineMeta>();
